// src/components/Tooltip.jsx

import React from 'react';
import './Tooltip.css';

export default function Tooltip({ children, text }) {
  return (
    <div className="tooltip-wrapper">
      {children}
      <span className="tooltip-text">{text}</span>
    </div>
  );
}